// Landline Switchover Helper — funnel logic, external script.
// Wrapped in an IIFE and exposed to window so onclick handlers in the
// liquid template can find these functions in global scope.
(function () {
const state = { step: 1, answers: {} };

  // ──────────────────────────────────────────────────────────────────────────
  // Shopify submission
  // Builds a readable message from the user's answers and fires the hidden
  // form. Shopify emails the store contact inbox AND creates a customer.
  // ──────────────────────────────────────────────────────────────────────────
  const ANSWER_LABELS = {
    who: {
      myself: 'Researching for themselves',
      parent: 'Researching for a parent or older relative',
      other:  'Researching for someone else'
    },
    broadband: {
      no: 'No broadband at the property',
      yes: 'Has broadband at the property',
      unsure: 'Not sure whether there is broadband'
    },
    landlineUsage: {
      'everyday':    'Uses the landline every day',
      'rarely':      'Rarely uses the landline',
      'not-at-all':  'Does not use the landline at all'
    }
  };

  const CONCERN_LABELS = {
    'power-cut':            'Works during a power cut',
    'keep-number':          'Keeps the existing phone number',
    'no-broadband-needed':  'Doesn\'t require broadband',
    'shared-household':     'Easy to pick up and use',
    'all-apply':            'All of the listed concerns apply',
    'none':                 'None of the listed concerns apply'
  };

  // Branch determination — runs at the moment we route the user to the offer.
  // Returns one of: 'broadband', 'silverline-fit', 'mobile-enough', 'weak-coverage'.
  function determineBranch() {
    const a = state.answers;
    if (a.broadband === 'yes') return 'broadband';
    if (a.landlineUsage === 'not-at-all') return 'mobile-enough';
    if (Array.isArray(a.concerns) && a.concerns.length === 1 && a.concerns[0] === 'none') {
      return 'mobile-enough';
    }
    // Otherwise the user looks like a SilverLine fit — but check coverage.
    // Weak 4G coverage (z > 3.5%) means we shouldn't recommend a 4G phone
    // confidently. Route them to a softer "check Ofcom first" offer.
    if (a.areaData && a.areaData.z > 3.5) {
      return 'weak-coverage';
    }
    return 'silverline-fit';
  }

  const BRANCH_LABELS = {
    'broadband':       '1 — Has broadband (provider can handle switchover)',
    'silverline-fit':  '2 — SilverLine 4G phone is the best fit',
    'mobile-enough':   '3 — A basic mobile is probably enough',
    'weak-coverage':   '4 — Weak 4G coverage (recommend Ofcom postcode check)'
  };

  const BRANCH_TAGS = {
    'broadband':       'branch-broadband',
    'silverline-fit':  'branch-silverline-fit',
    'mobile-enough':   'branch-mobile-enough',
    'weak-coverage':   'branch-weak-coverage'
  };

  function buildLeadMessage() {
    const a = state.answers;
    const branch = determineBranch();
    const coverageLabel = a.areaData
      ? (a.areaData.z > 3.5 ? 'weak' : a.areaData.z > 1.5 ? 'average' : 'good')
      : 'not provided';

    let concernsText = '—';
    if (Array.isArray(a.concerns) && a.concerns.length > 0) {
      concernsText = a.concerns
        .map(function (c) { return CONCERN_LABELS[c] || c; })
        .join('; ');
    }

    const lines = [
      '— RESEARCH FUNNEL LEAD —',
      '',
      'Researching for:  ' + (ANSWER_LABELS.who[a.who] || '—'),
      'Broadband:        ' + (ANSWER_LABELS.broadband[a.broadband] || '—'),
      'Landline use:     ' + (ANSWER_LABELS.landlineUsage[a.landlineUsage] || '—'),
      'Phone needs:      ' + concernsText,
      'Area:             ' + (a.area || '—') + ' (coverage rated ' + coverageLabel + ')',
      '',
      'Branch:           ' + (BRANCH_LABELS[branch] || branch),
      'Email captured:   ' + (a.emailSkipped ? 'Skipped in funnel, captured on offer page' : 'Captured in funnel')
    ];
    return lines.join('\n');
  }

  // (Old programmatic-submit approach removed. The new approach uses a real
  // form with a real submit button — see wireUpEmailForm() below.)


  const stepCount = 7; // 6 questions + thank you

  function updateProgress(stage) {
    document.querySelectorAll('.progress-step').forEach((el) => {
      const s = parseInt(el.dataset.stage);
      el.classList.remove('active', 'done');
      if (s < stage) el.classList.add('done');
      if (s === stage) el.classList.add('active');
    });
  }

  function showStep(n, direction) {
    // direction: 'forward' (default) or 'back'
    document.querySelectorAll('.step').forEach((el) => {
      el.classList.remove('active');
      el.classList.remove('back');
    });
    const el = document.querySelector(`.step[data-step="${n}"]`);
    if (el) {
      if (direction === 'back') el.classList.add('back');
      el.classList.add('active');
      updateProgress(parseInt(el.dataset.stage));
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    // Show the persistent Back button on every step except the first
    const topBack = document.getElementById('top-back-btn');
    if (topBack) {
      topBack.style.visibility = (n > 1) ? 'visible' : 'hidden';
    }
    // Populate the recommendation interstitial with user's selected concerns
    if (n === 4.5) {
      const summary = document.getElementById('recommendation-summary');
      if (summary) summary.textContent = buildRecommendationSummary();
    }
    // Populate the mobile-enough interstitial with a route-specific sentence
    if (n === 4.7) {
      const summary = document.getElementById('mobile-recommendation-summary');
      if (summary) summary.textContent = buildMobileRecommendationSummary();
    }
  }

  function answer(key, value) {
    state.answers[key] = value;
  }

  // Q3: How often is the landline used?
  // 'everyday' / 'rarely' advance to the concerns step (Q4).
  // 'not-at-all' skips concerns entirely and jumps to the mobile-enough
  // recommendation interstitial (Q4.7) — they're routed to Branch 3 at the
  // offer page.
  function answerLandlineUsage(value) {
    state.answers.landlineUsage = value;
    if (value === 'not-at-all') {
      state.step = 4.7;
      showStep(4.7);
    } else {
      next();
    }
  }

  // ──────────────────────────────────────────────────────────────────────────
  // Multi-select: Concerns question (Q4)
  // User can toggle multiple options. 'None of these apply' is mutually
  // exclusive with the others. The Continue button is disabled until at
  // least one option is selected.
  // ──────────────────────────────────────────────────────────────────────────
  function toggleConcern(btn, value) {
    if (!Array.isArray(state.answers.concerns)) state.answers.concerns = [];

    // 'all-apply' is mutually exclusive — if user picks it, behave like 'none'
    if (value === 'all-apply') {
      const wasSelected = btn.classList.contains('is-selected');
      // Clear everything first
      document.querySelectorAll('.option--multi.is-selected').forEach(function (el) {
        el.classList.remove('is-selected');
      });
      if (!wasSelected) {
        btn.classList.add('is-selected');
        state.answers.concerns = ['all-apply'];
      } else {
        state.answers.concerns = [];
      }
      updateConcernsContinue();
      return;
    }

    // For specific concerns: clear the mutually-exclusive options ('none', 'all-apply')
    ['none', 'all-apply'].forEach(function (excl) {
      const exclBtn = document.querySelector('.option--multi[data-concern="' + excl + '"]');
      if (exclBtn && exclBtn.classList.contains('is-selected')) {
        exclBtn.classList.remove('is-selected');
        state.answers.concerns = state.answers.concerns.filter(function (c) { return c !== excl; });
      }
    });

    const idx = state.answers.concerns.indexOf(value);
    if (idx === -1) {
      state.answers.concerns.push(value);
      btn.classList.add('is-selected');
    } else {
      state.answers.concerns.splice(idx, 1);
      btn.classList.remove('is-selected');
    }
    updateConcernsContinue();
  }

  function toggleConcernNone(btn) {
    // 'None of these' clears everything else
    document.querySelectorAll('.option--multi.is-selected').forEach(function (el) {
      el.classList.remove('is-selected');
    });
    const wasSelected = btn.classList.contains('is-selected');
    if (!wasSelected) {
      btn.classList.add('is-selected');
      state.answers.concerns = ['none'];
    } else {
      btn.classList.remove('is-selected');
      state.answers.concerns = [];
    }
    updateConcernsContinue();
  }

  function updateConcernsContinue() {
    const btn = document.getElementById('concerns-continue');
    if (!btn) return;
    const hasSelection = Array.isArray(state.answers.concerns) && state.answers.concerns.length > 0;
    btn.disabled = !hasSelection;
  }

  function submitConcerns() {
    if (!Array.isArray(state.answers.concerns) || state.answers.concerns.length === 0) return;
    // If user picked only "None of these apply" they're heading to Branch 3
    // (mobile-enough). Show the mobile-enough recommendation interstitial
    // (4.7) before coverage.
    const onlyNone = state.answers.concerns.length === 1 && state.answers.concerns[0] === 'none';
    if (onlyNone) {
      state.step = 4.7;
      showStep(4.7);
    } else {
      // SilverLine-fit path: show recommendation interstitial first.
      state.step = 4.5;
      showStep(4.5);
    }
  }

  // Build the "Based on what you've told us..." sentence shown on step 4.5,
  // listing the user's actual selected concerns inline so the recommendation
  // feels personalised rather than generic.
  function buildRecommendationSummary() {
    const concerns = state.answers.concerns || [];
    // The user-visible benefit phrases (lowercase, mid-sentence form)
    const BENEFIT_PHRASES = {
      'power-cut':            'works during a power cut',
      'keep-number':          'keeps the existing phone number',
      'no-broadband-needed':  'doesn\'t require broadband',
      'shared-household':     'is easy to pick up and use'
    };
    // If user picked "all-apply", expand to all four benefits
    let keys = concerns.indexOf('all-apply') !== -1
      ? ['power-cut', 'keep-number', 'no-broadband-needed', 'shared-household']
      : concerns.filter(function (c) { return BENEFIT_PHRASES[c]; });

    if (keys.length === 0) {
      return 'A 4G home phone matches what you need.';
    }

    const phrases = keys.map(function (k) { return BENEFIT_PHRASES[k]; });
    let list;
    if (phrases.length === 1) {
      list = phrases[0];
    } else if (phrases.length === 2) {
      list = phrases[0] + ' and ' + phrases[1];
    } else {
      list = phrases.slice(0, -1).join(', ') + ', and ' + phrases[phrases.length - 1];
    }
    return 'A 4G home phone ' + list + ', just like the landline you\'re used to.';
  }

  // Build the "Based on what you've told us..." sentence shown on step 4.7
  // (mobile-enough interstitial). Two variants based on which route the user
  // took into the branch: didn't use the landline at all, or used it but
  // selected only "None of these apply" on concerns.
  function buildMobileRecommendationSummary() {
    if (state.answers.landlineUsage === 'not-at-all') {
      return 'The landline isn\u2019t really being used day-to-day, so a basic mobile usually fits better. It works anywhere, not just at home.';
    }
    return 'Without specific home-phone needs (like power-cut backup or keeping an existing number), a basic mobile usually fits better. It works anywhere, not just at home.';
  }

  // Q2 'yes' path: divert to the honest-check interstitial instead of advancing
  function goToHonestCheck() {
    state.step = 2.5;
    showStep(2.5);
  }

  // User chose "Continue and send me the guide" on the broadband interstitial.
  // They're Branch 1 — the broadband-route lead. We skip the landline-usage
  // question, the concerns multi-select, and the coverage check, and jump
  // straight to email capture. The recommendation logic (determineBranch)
  // handles the rest.
  function honestChoiceContinue() {
    state.answers.broadbandInformed = true;
    state.step = 6;
    showStep(6);
  }

  function next() {
    if (state.step < stepCount) {
      // Both recommendation interstitials (4.5 silverline-fit, 4.7 mobile-enough)
      // advance to step 5 (coverage)
      if (state.step === 4.5 || state.step === 4.7) {
        state.step = 5;
      } else {
        state.step++;
      }
      showStep(state.step);
      if (state.step === 7) {
        // Branch: unsuitable leads (has broadband / weak coverage) see an
        // email-sent confirmation and do NOT proceed to the offer page.
        // We've captured their email for the guide / nurture sequence, but
        // we're not selling them a phone that isn't right for them.
        const title = document.getElementById('thankyou-title');
        const msg = document.getElementById('thankyou-message');
        if (state.answers.unsuitable) {
          title.textContent = 'Your guide is on its way';
          msg.innerHTML = `Guide sent to <strong>${escapeHtml(state.answers.email || 'your inbox')}</strong>.<br>Check your email in the next 2 minutes.`;
          // Do not auto-redirect.
        } else {
          title.textContent = 'Thank you!';
          msg.textContent = 'Finding the right phone for you…';
          setTimeout(showOffer, 2000);
        }
      }
    }
  }

  function back() {
    if (state.step <= 1) return;

    const a = state.answers;
    const concerns = a.concerns || [];
    const wentThroughInterstitial = concerns.length > 0 &&
      !(concerns.length === 1 && concerns[0] === 'none');
    const onlyNoneConcerns = concerns.length === 1 && concerns[0] === 'none';

    // Branch 1: from email step (6), if user came via broadband honest-check,
    // go back to that interstitial (2.5). Otherwise normal decrement.
    if (state.step === 6 && a.broadband === 'yes' && a.broadbandInformed) {
      state.step = 2.5;
    }
    // From coverage step (5), three possible back-targets:
    //   - SilverLine-fit path → step 4.5 (came via silverline-fit interstitial)
    //   - Mobile-enough path  → step 4.7 (came via mobile-enough interstitial)
    //   - Otherwise (shouldn't happen with current logic) → step 4
    else if (state.step === 5 && wentThroughInterstitial) {
      state.step = 4.5;
    }
    else if (state.step === 5 && (a.landlineUsage === 'not-at-all' || onlyNoneConcerns)) {
      state.step = 4.7;
    }
    // Step 4.5 back → step 4 (concerns)
    else if (state.step === 4.5) {
      state.step = 4;
    }
    // Step 4.7 back → step 3 (if route was 'not-at-all') or step 4 (if route was only-none concerns)
    else if (state.step === 4.7 && a.landlineUsage === 'not-at-all') {
      state.step = 3;
    }
    else if (state.step === 4.7) {
      state.step = 4;
    }
    // Honest-check (2.5) back goes to broadband question (2)
    else if (state.step === 2.5) {
      state.step = 2;
    }
    else {
      state.step--;
    }
    showStep(state.step, 'back');
  }

  // ──────────────────────────────────────────────────────────────────────────────
  // Coverage data: Ofcom Connected Nations Mobile Coverage, July 2025.
  // Source: https://www.ofcom.org.uk/phones-and-broadband/coverage-and-speeds/connected-nations-20252
  // Licence: Open Government Licence v3. Refresh when Ofcom publishes new data.
  //
  // Each entry: { n: area name, z: % premises with NO indoor 4G from any operator }.
  // The "good" % shown to the user is (100 - z).
  //
  // IMPORTANT LIMITATION: this is council-level average data. Individual
  // addresses can vary significantly. The UI always links to Ofcom's postcode-
  // level Map Your Mobile tool for users who want to check their exact address.
  // ──────────────────────────────────────────────────────────────────────────────
  const AREAS = [{"n":"Aberdeen City","z":0.0},{"n":"Aberdeenshire","z":0.9},{"n":"Adur","z":0.0},{"n":"Amber Valley","z":0.1},{"n":"Angus","z":0.5},{"n":"Antrim and Newtownabbey","z":0.3},{"n":"Ards and North Down","z":0.1},{"n":"Argyll and Bute","z":1.8},{"n":"Armagh City, Banbridge and Craigavon","z":1.4},{"n":"Arun","z":0.1},{"n":"Ashfield","z":0.0},{"n":"Ashford","z":0.8},{"n":"Babergh","z":1.2},{"n":"Barking and Dagenham","z":0.0},{"n":"Barnet","z":0.0},{"n":"Barnsley","z":0.1},{"n":"Basildon","z":0.0},{"n":"Basingstoke and Deane","z":0.2},{"n":"Bassetlaw","z":1.0},{"n":"Bath and North East Somerset","z":0.8},{"n":"Bedford","z":0.2},{"n":"Belfast","z":0.0},{"n":"Bexley","z":0.0},{"n":"Birmingham","z":0.0},{"n":"Blaby","z":0.0},{"n":"Blackburn with Darwen","z":0.0},{"n":"Blackpool","z":0.0},{"n":"Blaenau Gwent","z":0.1},{"n":"Bolsover","z":0.3},{"n":"Bolton","z":0.0},{"n":"Boston","z":0.2},{"n":"Bournemouth, Christchurch and Poole","z":0.0},{"n":"Bracknell Forest","z":0.0},{"n":"Bradford","z":0.1},{"n":"Braintree","z":1.1},{"n":"Breckland","z":1.2},{"n":"Brent","z":0.0},{"n":"Brentwood","z":0.1},{"n":"Bridgend","z":0.0},{"n":"Brighton and Hove","z":0.0},{"n":"Bristol, City of","z":0.0},{"n":"Broadland","z":1.0},{"n":"Bromley","z":0.0},{"n":"Bromsgrove","z":0.1},{"n":"Broxbourne","z":0.0},{"n":"Broxtowe","z":0.0},{"n":"Buckinghamshire","z":0.5},{"n":"Burnley","z":0.0},{"n":"Bury","z":0.0},{"n":"Caerphilly","z":0.0},{"n":"Calderdale","z":0.3},{"n":"Cambridge","z":0.0},{"n":"Camden","z":0.0},{"n":"Cannock Chase","z":0.0},{"n":"Canterbury","z":0.2},{"n":"Cardiff","z":0.0},{"n":"Carmarthenshire","z":2.4},{"n":"Castle Point","z":0.0},{"n":"Causeway Coast and Glens","z":1.5},{"n":"Central Bedfordshire","z":0.1},{"n":"Ceredigion","z":4.9},{"n":"Charnwood","z":0.2},{"n":"Chelmsford","z":0.3},{"n":"Cheltenham","z":0.0},{"n":"Cherwell","z":0.3},{"n":"Cheshire East","z":0.3},{"n":"Cheshire West and Chester","z":0.2},{"n":"Chesterfield","z":0.0},{"n":"Chichester","z":0.5},{"n":"Chorley","z":0.0},{"n":"City of Edinburgh","z":0.0},{"n":"City of London","z":0.0},{"n":"Clackmannanshire","z":0.0},{"n":"Colchester","z":0.7},{"n":"Conwy","z":1.2},{"n":"Cornwall","z":2.0},{"n":"Cotswold","z":1.6},{"n":"County Durham","z":0.4},{"n":"Coventry","z":0.0},{"n":"Crawley","z":0.0},{"n":"Croydon","z":0.0},{"n":"Cumberland","z":0.8},{"n":"Dacorum","z":0.3},{"n":"Darlington","z":0.0},{"n":"Dartford","z":0.0},{"n":"Denbighshire","z":1.2},{"n":"Derby","z":0.0},{"n":"Derbyshire Dales","z":2.7},{"n":"Derry City and Strabane","z":1.4},{"n":"Doncaster","z":0.1},{"n":"Dorset","z":0.9},{"n":"Dover","z":0.4},{"n":"Dudley","z":0.0},{"n":"Dumfries and Galloway","z":1.2},{"n":"Dundee City","z":0.0},{"n":"Ealing","z":0.0},{"n":"East Ayrshire","z":0.1},{"n":"East Cambridgeshire","z":0.8},{"n":"East Devon","z":0.9},{"n":"East Dunbartonshire","z":0.1},{"n":"East Hampshire","z":0.4},{"n":"East Hertfordshire","z":0.8},{"n":"East Lindsey","z":0.9},{"n":"East Lothian","z":0.2},{"n":"East Renfrewshire","z":0.0},{"n":"East Riding of Yorkshire","z":0.6},{"n":"East Staffordshire","z":0.6},{"n":"East Suffolk","z":1.3},{"n":"Eastbourne","z":0.0},{"n":"Eastleigh","z":0.0},{"n":"Elmbridge","z":0.0},{"n":"Enfield","z":0.0},{"n":"Epping Forest","z":0.7},{"n":"Epsom and Ewell","z":0.0},{"n":"Erewash","z":0.0},{"n":"Exeter","z":0.0},{"n":"Falkirk","z":0.1},{"n":"Fareham","z":0.0},{"n":"Fenland","z":1.3},{"n":"Fermanagh and Omagh","z":2.6},{"n":"Fife","z":0.2},{"n":"Flintshire","z":0.6},{"n":"Folkestone and Hythe","z":0.2},{"n":"Forest of Dean","z":2.7},{"n":"Fylde","z":0.2},{"n":"Gateshead","z":0.1},{"n":"Gedling","z":0.0},{"n":"Glasgow City","z":0.0},{"n":"Gloucester","z":0.0},{"n":"Gosport","z":0.0},{"n":"Gravesham","z":0.5},{"n":"Great Yarmouth","z":0.1},{"n":"Greenwich","z":0.0},{"n":"Guildford","z":0.4},{"n":"Gwynedd","z":2.1},{"n":"Hackney","z":0.0},{"n":"Halton","z":0.0},{"n":"Hammersmith and Fulham","z":0.0},{"n":"Harborough","z":1.0},{"n":"Haringey","z":0.0},{"n":"Harlow","z":0.0},{"n":"Harrow","z":0.0},{"n":"Hart","z":0.0},{"n":"Hartlepool","z":0.0},{"n":"Hastings","z":0.0},{"n":"Havant","z":0.0},{"n":"Havering","z":0.0},{"n":"Herefordshire, County of","z":1.6},{"n":"Hertsmere","z":0.0},{"n":"High Peak","z":1.1},{"n":"Highland","z":1.6},{"n":"Hillingdon","z":0.0},{"n":"Hinckley and Bosworth","z":0.3},{"n":"Horsham","z":0.1},{"n":"Hounslow","z":0.0},{"n":"Huntingdonshire","z":0.3},{"n":"Hyndburn","z":0.0},{"n":"Inverclyde","z":0.1},{"n":"Ipswich","z":0.0},{"n":"Isle of Anglesey","z":0.8},{"n":"Isle of Wight","z":0.2},{"n":"Isles of Scilly","z":5.7},{"n":"Islington","z":0.0},{"n":"Kensington and Chelsea","z":0.0},{"n":"King's Lynn and West Norfolk","z":0.7},{"n":"Kingston upon Hull, City of","z":0.0},{"n":"Kingston upon Thames","z":0.0},{"n":"Kirklees","z":0.1},{"n":"Knowsley","z":0.0},{"n":"Lambeth","z":0.0},{"n":"Lancaster","z":1.3},{"n":"Leeds","z":0.0},{"n":"Leicester","z":0.0},{"n":"Lewes","z":0.1},{"n":"Lewisham","z":0.0},{"n":"Lichfield","z":0.4},{"n":"Lincoln","z":0.0},{"n":"Lisburn and Castlereagh","z":0.2},{"n":"Liverpool","z":0.0},{"n":"Luton","z":0.0},{"n":"Maidstone","z":0.7},{"n":"Maldon","z":1.2},{"n":"Malvern Hills","z":1.6},{"n":"Manchester","z":0.0},{"n":"Mansfield","z":0.1},{"n":"Medway","z":0.1},{"n":"Melton","z":2.1},{"n":"Merthyr Tydfil","z":0.1},{"n":"Merton","z":0.0},{"n":"Mid and East Antrim","z":0.6},{"n":"Mid Devon","z":2.6},{"n":"Mid Suffolk","z":2.2},{"n":"Mid Sussex","z":0.4},{"n":"Mid Ulster","z":2.9},{"n":"Middlesbrough","z":0.0},{"n":"Midlothian","z":0.1},{"n":"Milton Keynes","z":0.0},{"n":"Mole Valley","z":1.1},{"n":"Monmouthshire","z":2.1},{"n":"Moray","z":0.5},{"n":"Na h-Eileanan Siar","z":2.5},{"n":"Neath Port Talbot","z":0.4},{"n":"New Forest","z":0.6},{"n":"Newark and Sherwood","z":0.7},{"n":"Newcastle upon Tyne","z":0.0},{"n":"Newcastle-under-Lyme","z":0.0},{"n":"Newham","z":0.0},{"n":"Newport","z":0.1},{"n":"Newry, Mourne and Down","z":4.7},{"n":"North Ayrshire","z":0.1},{"n":"North Devon","z":3.0},{"n":"North East Derbyshire","z":0.6},{"n":"North East Lincolnshire","z":0.2},{"n":"North Hertfordshire","z":0.1},{"n":"North Kesteven","z":0.5},{"n":"North Lanarkshire","z":0.0},{"n":"North Lincolnshire","z":0.6},{"n":"North Norfolk","z":3.0},{"n":"North Northamptonshire","z":0.5},{"n":"North Somerset","z":0.3},{"n":"North Tyneside","z":0.0},{"n":"North Warwickshire","z":0.7},{"n":"North West Leicestershire","z":0.2},{"n":"North Yorkshire","z":1.5},{"n":"Northumberland","z":0.7},{"n":"Norwich","z":0.0},{"n":"Nottingham","z":0.0},{"n":"Nuneaton and Bedworth","z":0.0},{"n":"Oadby and Wigston","z":0.0},{"n":"Oldham","z":0.0},{"n":"Orkney Islands","z":2.4},{"n":"Oxford","z":0.0},{"n":"Pembrokeshire","z":2.1},{"n":"Pendle","z":0.4},{"n":"Perth and Kinross","z":0.8},{"n":"Peterborough","z":0.0},{"n":"Plymouth","z":0.0},{"n":"Portsmouth","z":0.0},{"n":"Powys","z":4.0},{"n":"Preston","z":0.1},{"n":"Reading","z":0.0},{"n":"Redbridge","z":0.0},{"n":"Redcar and Cleveland","z":0.1},{"n":"Redditch","z":0.0},{"n":"Reigate and Banstead","z":0.0},{"n":"Renfrewshire","z":0.0},{"n":"Rhondda Cynon Taf","z":0.1},{"n":"Ribble Valley","z":0.8},{"n":"Richmond upon Thames","z":0.0},{"n":"Rochdale","z":0.0},{"n":"Rochford","z":0.8},{"n":"Rossendale","z":0.1},{"n":"Rother","z":0.7},{"n":"Rotherham","z":0.1},{"n":"Rugby","z":0.4},{"n":"Runnymede","z":0.1},{"n":"Rushcliffe","z":0.8},{"n":"Rushmoor","z":0.0},{"n":"Rutland","z":0.6},{"n":"Salford","z":0.0},{"n":"Sandwell","z":0.0},{"n":"Scottish Borders","z":0.9},{"n":"Sefton","z":0.0},{"n":"Sevenoaks","z":0.8},{"n":"Sheffield","z":0.1},{"n":"Shetland Islands","z":1.4},{"n":"Shropshire","z":1.6},{"n":"Slough","z":0.0},{"n":"Solihull","z":0.0},{"n":"Somerset","z":1.0},{"n":"South Ayrshire","z":0.5},{"n":"South Cambridgeshire","z":0.2},{"n":"South Derbyshire","z":1.1},{"n":"South Gloucestershire","z":0.0},{"n":"South Hams","z":3.2},{"n":"South Holland","z":1.8},{"n":"South Kesteven","z":0.4},{"n":"South Lanarkshire","z":0.3},{"n":"South Norfolk","z":2.2},{"n":"South Oxfordshire","z":0.3},{"n":"South Ribble","z":0.0},{"n":"South Staffordshire","z":0.0},{"n":"South Tyneside","z":0.0},{"n":"Southampton","z":0.0},{"n":"Southend-on-Sea","z":0.0},{"n":"Southwark","z":0.0},{"n":"Spelthorne","z":0.0},{"n":"St Albans","z":0.0},{"n":"St. Helens","z":0.0},{"n":"Stafford","z":0.2},{"n":"Staffordshire Moorlands","z":1.6},{"n":"Stevenage","z":0.0},{"n":"Stirling","z":0.5},{"n":"Stockport","z":0.1},{"n":"Stockton-on-Tees","z":0.0},{"n":"Stoke-on-Trent","z":0.0},{"n":"Stratford-on-Avon","z":0.7},{"n":"Stroud","z":0.9},{"n":"Sunderland","z":0.0},{"n":"Surrey Heath","z":0.1},{"n":"Sutton","z":0.0},{"n":"Swale","z":0.3},{"n":"Swansea","z":0.1},{"n":"Swindon","z":0.0},{"n":"Tameside","z":0.0},{"n":"Tamworth","z":0.0},{"n":"Tandridge","z":0.3},{"n":"Teignbridge","z":1.3},{"n":"Telford and Wrekin","z":0.7},{"n":"Tendring","z":0.2},{"n":"Test Valley","z":0.6},{"n":"Tewkesbury","z":0.4},{"n":"Thanet","z":0.0},{"n":"Three Rivers","z":0.2},{"n":"Thurrock","z":0.0},{"n":"Tonbridge and Malling","z":0.3},{"n":"Torbay","z":0.1},{"n":"Torfaen","z":0.1},{"n":"Torridge","z":1.9},{"n":"Tower Hamlets","z":0.0},{"n":"Trafford","z":0.0},{"n":"Tunbridge Wells","z":0.4},{"n":"Uttlesford","z":2.4},{"n":"Vale of Glamorgan","z":0.3},{"n":"Vale of White Horse","z":0.1},{"n":"Wakefield","z":0.0},{"n":"Walsall","z":0.0},{"n":"Waltham Forest","z":0.0},{"n":"Wandsworth","z":0.0},{"n":"Warrington","z":0.0},{"n":"Warwick","z":0.0},{"n":"Watford","z":0.0},{"n":"Waverley","z":0.8},{"n":"Wealden","z":1.2},{"n":"Welwyn Hatfield","z":0.0},{"n":"West Berkshire","z":0.5},{"n":"West Devon","z":4.0},{"n":"West Dunbartonshire","z":0.0},{"n":"West Lancashire","z":0.2},{"n":"West Lindsey","z":1.3},{"n":"West Lothian","z":0.1},{"n":"West Northamptonshire","z":0.4},{"n":"West Oxfordshire","z":0.8},{"n":"West Suffolk","z":0.9},{"n":"Westminster","z":0.0},{"n":"Westmorland and Furness","z":1.9},{"n":"Wigan","z":0.0},{"n":"Wiltshire","z":0.9},{"n":"Winchester","z":0.7},{"n":"Windsor and Maidenhead","z":0.0},{"n":"Wirral","z":0.0},{"n":"Woking","z":0.0},{"n":"Wokingham","z":0.0},{"n":"Wolverhampton","z":0.0},{"n":"Worcester","z":0.0},{"n":"Worthing","z":0.0},{"n":"Wrexham","z":0.5},{"n":"Wychavon","z":0.8},{"n":"Wyre","z":0.8},{"n":"Wyre Forest","z":0.4},{"n":"York","z":0.0}];

  // Classify based on % of premises with no indoor 4G from any operator
  // Thresholds chosen from distribution analysis: >3.5% = notable rural problem,
  // 1.5-3.5% = patchy average, <1.5% = effectively universal.
  function classifyArea(area) {
    if (!area) return 'good';
    if (area.z > 3.5) return 'poor';
    if (area.z > 1.5) return 'patchy';
    return 'good';
  }

  // ─── Autocomplete combobox ───────────────────────────────────────────────────
  let activeOption = -1;
  let filteredAreas = [];

  function onCountyInput() {
    const q = document.getElementById('county-input').value.trim().toLowerCase();
    const list = document.getElementById('county-list');
    if (!q) {
      // Show top 8 alphabetical on empty focus
      filteredAreas = AREAS.slice(0, 8);
    } else {
      filteredAreas = AREAS.filter(a => a.n.toLowerCase().includes(q)).slice(0, 10);
    }
    renderCountyList();
    list.style.display = 'block';
    activeOption = -1;
  }

  function renderCountyList() {
    const list = document.getElementById('county-list');
    if (filteredAreas.length === 0) {
      list.innerHTML = '<div class="combobox-empty">No matches. Try a nearby council.</div>';
      return;
    }
    list.innerHTML = filteredAreas.map((a, i) =>
      `<div class="combobox-option" data-index="${i}" onmousedown="pickCounty(${i})">` +
        `<span>${escapeHtml(a.n)}</span>` +
      `</div>`
    ).join('');
  }

  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]);
  }

  function onCountyKey(e) {
    const list = document.getElementById('county-list');
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeOption = Math.min(activeOption + 1, filteredAreas.length - 1);
      updateActiveOption();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      activeOption = Math.max(activeOption - 1, 0);
      updateActiveOption();
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeOption >= 0) pickCounty(activeOption);
      else if (filteredAreas.length === 1) pickCounty(0);
    } else if (e.key === 'Escape') {
      list.style.display = 'none';
    }
  }

  function updateActiveOption() {
    document.querySelectorAll('.combobox-option').forEach((el, i) => {
      el.classList.toggle('active', i === activeOption);
    });
  }

  function pickCounty(index) {
    const area = filteredAreas[index];
    if (!area) return;
    document.getElementById('county-input').value = area.n;
    document.getElementById('county-list').style.display = 'none';
    state.answers.area = area.n;
    state.answers.areaData = area;
    showCoverageResult(area);
  }

  // Hide list when clicking outside
  document.addEventListener('click', (e) => {
    const list = document.getElementById('county-list');
    const input = document.getElementById('county-input');
    if (list && input && !input.contains(e.target) && !list.contains(e.target)) {
      list.style.display = 'none';
    }
  });

  // ─── Show result for selected area ───────────────────────────────────────────
  function showCoverageResult(area) {
    document.querySelectorAll('.step').forEach((el) => el.classList.remove('active'));
    document.querySelector('.step[data-step="5.5"]').classList.add('active');
    ['coverage-confirmed','coverage-patchy','coverage-poor'].forEach(id => {
      document.getElementById(id).style.display = 'none';
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const level = classifyArea(area);
    const goodPct = (100 - area.z).toFixed(0);

    if (level === 'good') {
      document.getElementById('coverage-confirmed').style.display = 'block';
      document.getElementById('coverage-area').textContent = area.n;
      document.getElementById('coverage-confirmed-detail').textContent =
        `Ofcom rates indoor 4G coverage in ${area.n} as good. The phone should work well at most addresses.`;
      setTimeout(() => { state.step = 6; showStep(6); }, 3000);
    } else if (level === 'patchy') {
      document.getElementById('coverage-patchy').style.display = 'block';
      document.getElementById('coverage-patchy-area').textContent = area.n;
      document.getElementById('coverage-patchy-detail').textContent =
        `Ofcom rates indoor 4G coverage in ${area.n} as average. The phone should work at most addresses, but coverage is weaker in parts of the area.`;
    } else {
      document.getElementById('coverage-poor').style.display = 'block';
      document.getElementById('coverage-poor-area').textContent = area.n;
      document.getElementById('coverage-poor-detail').textContent =
        `Ofcom rates indoor 4G coverage in ${area.n} as weak, noticeably below most UK areas. A 4G home phone may struggle here.`;
    }
  }


  // ──────────────────────────────────────────────────────────────────────────
  // EMAIL FORM — using Shopify's {% form 'contact' %} Liquid tag.
  //
  // Flow:
  //   1. User reaches step 6 with answers in `state.answers`
  //   2. On submit: we fill contact[body] with lead details, save state to
  //      sessionStorage (so it survives the redirect), and let the form post
  //   3. Shopify validates captcha/CSRF and processes the submission
  //   4. Shopify redirects back to the page with ?contact_posted=true or
  //      sets form.posted_successfully? in Liquid
  //   5. On page load, we check sessionStorage. If we came from a successful
  //      submit, restore state, fire the customer-signup, and jump to step 7
  // ──────────────────────────────────────────────────────────────────────────

  const RSH_STATE_KEY = 'rsh-funnel-state';
  const RSH_SUBMITTED_FLAG = 'rsh-funnel-submitted';

  function saveStateBeforeSubmit() {
    try {
      sessionStorage.setItem(RSH_STATE_KEY, JSON.stringify(state.answers));
      sessionStorage.setItem(RSH_SUBMITTED_FLAG, '1');
    } catch (e) { /* private mode, ignore */ }
  }

  function restoreStateAfterSubmit() {
    try {
      if (sessionStorage.getItem(RSH_SUBMITTED_FLAG) !== '1') return false;
      const saved = sessionStorage.getItem(RSH_STATE_KEY);
      if (saved) {
        state.answers = JSON.parse(saved);
      }
      // Clear flags so a subsequent reload doesn't re-trigger
      sessionStorage.removeItem(RSH_STATE_KEY);
      sessionStorage.removeItem(RSH_SUBMITTED_FLAG);
      return true;
    } catch (e) {
      return false;
    }
  }

  function fireCustomerSignup(email) {
    if (!email) return;
    try {
      const fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'research-funnel, lead');
      fetch('/contact', { method: 'POST', body: fd, mode: 'no-cors' });
    } catch (e) {
      console.warn('[RSH] customer signup failed:', e);
    }
  }

  function wireUpEmailForm() {
    const form = document.getElementById('rsh-email-form');
    if (!form) return;

    form.addEventListener('submit', function () {
      const email = document.getElementById('email').value.trim();
      state.answers.email = email;
      state.answers.emailSkipped = false;
      // Put the full lead details into the customer's Note field so you can
      // see their situation when opening the customer record in admin.
      document.getElementById('rsh-sf-note').value = buildLeadMessage();
      // Append the branch-specific tag so leads can be segmented in Shopify
      const branchTag = BRANCH_TAGS[determineBranch()];
      if (branchTag) {
        document.getElementById('rsh-sf-tags').value = 'research-funnel, lead, ' + branchTag;
      }
      saveStateBeforeSubmit();

      // Let the form submit naturally via full page navigation.
      // Shopify handles captcha, CSRF, and redirects back to the same page.
    });
  }

  function handlePostSubmitReturn() {
    // Multiple detection paths — use whichever fires:
    //   1. window.rshPostedSuccessfully set by Liquid's form.posted_successfully?
    //   2. sessionStorage flag (our own bookkeeping)
    //   3. URL hash contains #rsh-email-form — Shopify always adds this after
    //      a successful contact form submit (#contact_form by default, but we
    //      overrode the form id so it becomes our id)
    const urlMatch = window.location.hash.indexOf('rsh-email-form') !== -1;
    const restored = restoreStateAfterSubmit();
    const liquidFlag = window.rshPostedSuccessfully === true;

    const returnedFromPost = liquidFlag || restored || urlMatch;
    if (!returnedFromPost) return false;

    // Clean the URL (remove the #rsh-email-form anchor) so refresh doesn't loop
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    // Restore state (if we didn't already via sessionStorage), jump to thank-you
    if (!restored) {
      // Last-resort: try reading sessionStorage even if the flag wasn't set
      try {
        const saved = sessionStorage.getItem(RSH_STATE_KEY);
        if (saved) state.answers = JSON.parse(saved);
        sessionStorage.removeItem(RSH_STATE_KEY);
        sessionStorage.removeItem(RSH_SUBMITTED_FLAG);
      } catch (e) { /* ignore */ }
    }

    state.step = 7;
    showStep(7);

    // Run the same finalisation logic that next() would run on arrival at
    // step 7 — set the thank-you copy and schedule the auto-advance to the
    // offer page (unless the lead was unsuitable).
    const title = document.getElementById('thankyou-title');
    const msg = document.getElementById('thankyou-message');
    if (state.answers.unsuitable) {
      if (title) title.textContent = 'Your guide is on its way';
      if (msg) msg.innerHTML = 'Guide sent to <strong>' +
        escapeHtml(state.answers.email || 'your inbox') +
        '</strong>.<br>Check your email in the next 2 minutes.';
    } else {
      if (title) title.textContent = 'Thank you!';
      if (msg) msg.textContent = 'Finding the right phone for you…';
      setTimeout(showOffer, 2000);
    }

    // Customer signup already fired at submit time via the hidden form —
    // see wireUpEmailForm() — so nothing to do here.
    return true;
  }

  wireUpEmailForm();
  wireUpOfferEmailForm();

  function skipEmail() {
    // User explicitly declined to give email in the funnel.
    state.answers.email = null;
    state.answers.emailSkipped = true;
    if (state.answers.unsuitable) {
      // Unsuitable + no email = no path forward. Close the funnel politely.
      state.step = 7;
      showStep(7);
      document.getElementById('thankyou-title').textContent = 'Thanks for visiting';
      document.getElementById('thankyou-message').innerHTML =
        'Based on your answers, a 4G home phone may not be the right fit.<br>You can check your exact address on <a href="https://www.ofcom.org.uk/mobile-coverage-checker" target="_blank" rel="noopener" style="color: var(--navy); font-weight: 600;">Ofcom\'s Map Your Mobile</a> for more detail.';
      return;
    }
    // Skip the thank-you interstitial and go straight to the offer page,
    // where we'll show the email capture as a fallback.
    showOffer();
  }

  // Headline + lede copy for each branch, used on the offer page.
  const OFFER_VARIANTS = {
    'broadband': {
      capturedHeadline: 'Sounds like your provider can handle this.',
      skippedHeadline:  'Sounds like your provider can handle this.',
      lede: 'With broadband at the home, the existing phone provider will usually handle the switchover for free. But some people still prefer a 4G home phone for one good reason: it doesn\'t depend on the broadband router. If the broadband goes down, the phone still works.'
    },
    'silverline-fit': {
      capturedHeadline: 'Your switchover guide is on its way.',
      skippedHeadline:  'Meet the SilverLine 4G Home Phone.',
      lede: 'Based on what you\'ve told us, the <strong>SilverLine 4G Home Phone</strong> tends to be the best fit. A familiar looking home phone that works anywhere there\'s a mobile signal, without needing broadband or a mobile contract.'
    },
    'mobile-enough': {
      capturedHeadline: 'A mobile phone might be all you need.',
      skippedHeadline:  'A mobile phone might be all you need.',
      lede: 'Based on what you\'ve told us, a basic mobile phone would probably suit you fine. We\'ll still send you the switchover guide so you have all the options in one place. <strong>If you\'d rather have something that looks and feels like a home phone</strong>, the SilverLine 4G Home Phone is what we make.'
    },
    'weak-coverage': {
      capturedHeadline: 'Worth checking 4G coverage at the address first.',
      skippedHeadline:  'Worth checking 4G coverage at the address first.',
      lede: 'Based on your area, 4G coverage can be patchy at some addresses. Before deciding on a 4G home phone, it\'s worth checking <a href="https://www.ofcom.org.uk/phones-and-broadband/mobile-phones/coverage-checker" target="_blank" rel="noopener">Ofcom\'s postcode-level coverage tool</a> to see what the signal looks like at the home itself. If it\'s strong, the <strong>SilverLine 4G Home Phone</strong> would be a good fit. If not, you may want to ask your existing phone provider about broadband-based alternatives.'
    }
  };

  function showOffer() {
    document.getElementById('funnel-view').style.display = 'none';
    document.getElementById('offer-view').classList.add('active');
    window.scrollTo({ top: 0, behavior: 'auto' });

    // Reveal the theme's header + footer now that the user has reached the
    // offer page. They were hidden on page load via the .rsh-hide-chrome
    // class on <html> (see inline style block in the template).
    document.documentElement.classList.remove('rsh-hide-chrome');

    const branch = determineBranch();
    const variant = OFFER_VARIANTS[branch] || OFFER_VARIANTS['silverline-fit'];

    const captured = document.getElementById('offer-path-captured');
    const skipped = document.getElementById('offer-path-skipped');
    const headline = document.getElementById('offer-headline');
    const lede = document.getElementById('offer-lede');

    // Tag the offer view so CSS can lighten the CTA on Branch 3 if needed
    const offerView = document.getElementById('offer-view');
    if (offerView) {
      offerView.classList.remove('branch-broadband', 'branch-silverline-fit', 'branch-mobile-enough', 'branch-weak-coverage');
      offerView.classList.add('branch-' + branch);
    }

    lede.innerHTML = variant.lede;

    if (state.answers.emailSkipped) {
      // User declined email in funnel, show email capture fallback + buy CTA
      captured.style.display = 'none';
      skipped.style.display = 'block';
      headline.textContent = variant.skippedHeadline;
      // Reset the offer-page capture form to its default state
      document.getElementById('oec-form').style.display = 'block';
      document.getElementById('oec-confirmed').style.display = 'none';
      const offerEmailInput = document.getElementById('offer-email');
      if (offerEmailInput) offerEmailInput.value = '';
    } else {
      // Email was captured in funnel, show "guide sent" confirmation + buy CTA
      captured.style.display = 'block';
      skipped.style.display = 'none';
      headline.textContent = variant.capturedHeadline;
      if (state.answers.email) {
        document.getElementById('captured-email').textContent = state.answers.email;
      }
    }
  }

  // ──────────────────────────────────────────────────────────────────────────
  // OFFER-PAGE SKIP FORM
  // Native Shopify {% form 'customer' %}. User clicks real submit button,
  // form posts via full page navigation, Shopify redirects back with
  // form.posted_successfully? which our Liquid sets window.rshOfferPostedSuccessfully.
  // ──────────────────────────────────────────────────────────────────────────
  const RSH_OFFER_FLAG_KEY = 'rsh-funnel-offer-submitted';

  function wireUpOfferEmailForm() {
    const form = document.getElementById('rsh-offer-email-form');
    if (!form) return;

    form.addEventListener('submit', function () {
      const email = document.getElementById('offer-email').value.trim();
      state.answers.email = email;
      state.answers.emailSkipped = false;
      // Fill note field with lead details (same buildLeadMessage as funnel form)
      document.getElementById('rsh-offer-note').value = buildLeadMessage();
      // Append the branch-specific tag so leads can be segmented in Shopify
      const branchTag = BRANCH_TAGS[determineBranch()];
      if (branchTag) {
        document.getElementById('rsh-offer-tags').value = 'research-funnel, lead, offer-page-capture, ' + branchTag;
      }
      // Save state + flag that we came from the offer skip-path
      try {
        sessionStorage.setItem(RSH_STATE_KEY, JSON.stringify(state.answers));
        sessionStorage.setItem(RSH_SUBMITTED_FLAG, '1');
        sessionStorage.setItem(RSH_OFFER_FLAG_KEY, '1');
      } catch (e) { /* private mode */ }
      // Native form submission proceeds
    });
  }

  function handleOfferPostSubmitReturn() {
    // Only fires if we returned from an offer-page-skip form submission
    const liquidFlag = window.rshOfferPostedSuccessfully === true;
    const storageFlag = (function () {
      try { return sessionStorage.getItem(RSH_OFFER_FLAG_KEY) === '1'; }
      catch (e) { return false; }
    })();
    if (!liquidFlag && !storageFlag) return false;

    // Clear the flag
    try { sessionStorage.removeItem(RSH_OFFER_FLAG_KEY); } catch (e) {}

    // Clean the URL
    if (window.history && window.history.replaceState) {
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    // Restore state
    try {
      const saved = sessionStorage.getItem(RSH_STATE_KEY);
      if (saved) state.answers = JSON.parse(saved);
      sessionStorage.removeItem(RSH_STATE_KEY);
      sessionStorage.removeItem(RSH_SUBMITTED_FLAG);
    } catch (e) { /* ignore */ }

    // Jump straight to offer view, with the confirmation showing
    showOffer();
    // Show the confirmed state (not the form) on the skip-path card
    const formCard = document.getElementById('oec-form');
    const confirmedCard = document.getElementById('oec-confirmed');
    if (formCard) formCard.style.display = 'none';
    if (confirmedCard) confirmedCard.style.display = 'block';
    const confirmedEmail = document.getElementById('oec-confirmed-email');
    if (confirmedEmail) confirmedEmail.textContent = state.answers.email || 'your inbox';

    return true;
  }

  // The old captureOfferEmail kept as a shim in case anything still references it.
  function captureOfferEmail() {
    const form = document.getElementById('rsh-offer-email-form');
    if (form) form.requestSubmit();
  }

  // init — check return paths in order:
  //   1. Returning from offer-page skip-form submission → jump to offer view
  //   2. Returning from main funnel email submission → jump to thank-you step
  //   3. Fresh visit → start at step 1
  if (!handleOfferPostSubmitReturn() && !handlePostSubmitReturn()) {
    showStep(1);
  }

  // Expose everything referenced from inline HTML event handlers
  // (including handlers set from within JS-generated HTML like the county
  //  dropdown options).
  window.answer = answer;
  window.answerLandlineUsage = answerLandlineUsage;
  window.back = back;
  window.captureOfferEmail = captureOfferEmail;
  window.goToHonestCheck = goToHonestCheck;
  window.honestChoiceContinue = honestChoiceContinue;
  window.next = next;
  window.onCountyInput = onCountyInput;
  window.onCountyKey = onCountyKey;
  window.pickCounty = pickCounty;
  window.showStep = showStep;
  window.skipEmail = skipEmail;
  window.state = state;
  window.toggleConcern = toggleConcern;
  window.toggleConcernNone = toggleConcernNone;
  window.submitConcerns = submitConcerns;
})();